import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { Grid, Paper } from '@material-ui/core'

import { getWordVault } from '../../../../redux/actions'

import WordVaultMain from './WordVaultMain'
import WordVaultList from './WordVaultList'
import WordVaultNew from './WordVaultNew'
import WordVaultEdit from './WordVaultEdit'

import { ConfirmToast } from '../../tools'

import { keyify2, getSeverityClass } from '../../../../utils'

import { withStyles, makeStyles, fade } from '@material-ui/core/styles'

import Switch from '@material-ui/core/Switch'
import Checkbox from '@material-ui/core/Checkbox'
import Slider from '@material-ui/core/Slider'

import TreeView from '@material-ui/lab/TreeView'
import UnitTree from '../../tools/UnitTree'

import Swal from 'sweetalert2'

const WordNotification = Swal.mixin({
  toast: true,
  position: 'top',
  showConfirmButton: false,
  timer: 6000,
  timerProgressBar: true,
  onOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})

const StyledSwitch = withStyles({
  switchBase: {
    color: 'white',
    '&$checked': {
      color: '#A4D164'
    },
    '&$checked + $track': {
      backgroundColor: '#A4D164'
    }
  },
  checked: {},
  track: {}
})(Switch)

const StyledCheckBox = withStyles({
  root: {
    color: '#A4D164',
    '&$checked': {
      color: '#A4D164'
    }
  },
  checked: {}
})((props) => <Checkbox color='default' {...props} />)

const CustomSlider = withStyles({
  root: {
    height: '5px'
  },
  rail: {
    backgroundImage: 'linear-gradient(to right, rgba(82,145,252,1) 20%, rgba(78,23,154,1) 20% 40%, rgba(245,216,24,1) 40% 60%, rgba(231,132,15,1) 60% 80%, rgba(211,17,17,1) 80%)',
    height: '5px'
  },
  track: {
    // backgroundImage: 'linear-gradient(to right, rgba(82,145,252,1) 20%, rgba(78,23,154,1) 20% 40%, rgba(231,132,15,1) 40% 60%, rgba(245,216,24,1) 60% 80%, rgba(211,17,17,1) 80%)',
    height: '5px'
  },
  mark: {
    height: '5px',
    width: '5px',
    backgroundColor: '#fff'
  },
  markActive: {
    opacity: 1,
    backgroundColor: '#fff'
  }
})(Slider)

const useStyles = makeStyles((theme) => ({
  editPaper: {
    backgroundColor: theme.palette.background.default,
    maxHeight: '45em',
    overflow: 'scroll'
  },
  backBtn: {
    backgroundColor: '#8BB84B',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#588518'
    }
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade('#868787', 0.15),
    '&:hover': {
      backgroundColor: fade('#868787', 0.25)
    },
    width: '100%'
  },
  searchIcon: {
    padding: theme.spacing(0, 1),
    height: '100%',
    position: 'absolute',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  inputRoot: {
    color: 'inherit',
    width: '100%'
  },
  inputInput: {
    padding: theme.spacing(2, 1, 2, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(5)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%'
  },
  searchBtn: {
    color: '#ffffff',
    backgroundColor: '#3984f7',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  tableHeader: {
    backgroundColor: theme.palette.divider,
    opacity: '0.85'
  },
  deleteExp: {
    backgroundColor: theme.palette.error.light,
    '&:hover': {
      backgroundColor: '#B24040'
    }
  },
  expBtn: {
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  saveBtn: {
    marginRight: '1rem',
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  wordCard: {
    width: '85%',
    margin: theme.spacing(2, 0)
  },
  wordContent: {
    paddingBottom: '0em !important',
    paddingRight: '0em',
    paddingTop: '0.5em'
  },
  severity: {
    width: '100%',
    height: '100%'
  },
  severityAvatar: {
    // padding: theme.spacing(2, 2)
  },
  mild: {
    background: '#5291fc'
  },
  okay: {
    background: '#4e179a',
    color: '#ffffff'
  },
  notGreat: {
    background: '#e7840f',
    color: '#ffffff'
  },
  warn: {
    background: '#f5d818',
    color: '#414342'
  },
  bad: {
    background: '#d31111',
    color: '#ffffff'
  },
  vaultPaper: {
    backgroundColor: theme.palette.background.default
  },
  categoryTitle: {
    textTransform: 'none'
  },
  editBtn: {
    backgroundColor: '#8BB84B',
    color: '#fff',
    width: theme.spacing(2),
    height: theme.spacing(4),
    '&:hover': {
      backgroundColor: '#588518'
    }
  },
  wordContainer: {
    maxHeight: '32.5em',
    overflow: 'scroll'
  },
  scoreDivider: {
    height: '1px',
    width: '75%',
    backgroundColor: '#fff'
  },
  darkScoreDivider: {
    height: '1px',
    width: '75%',
    backgroundColor: '#414342'
  },
  phraseChip: {
    width: '100%',
    height: 'auto',
    marginBottom: '.4rem'
  },
  label: {
    width: '100%',
    paddingRight: '0%'
  },
  deleteBtn: {
    backgroundColor: theme.palette.error.light,
    margin: 'auto',
    '&:hover': {
      backgroundColor: '#B24040'
    }
  },
  addBtn: {
    backgroundColor: '#8BB84B',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#588518'
    }
  },
  discardBtn: {
    backgroundColor: '#B7C5D0',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#84929D'
    }
  },
  enableText: {
    color: '#A4D164',
    fontWeight: 'bold'
  },
  disabledText: {
    fontWeight: 'bold'
  },
  disabledAvatar: {
    backgroundColor: theme.palette.divider
  },
  enabledAvatar: {
    backgroundColor: '#3984f7'
  },
  vaultImg: {
    // height: '100%',
    width: '100%',
    paddingTop: '100%'
  },
  vaultChip: {
    width: '18em',
    height: 'auto',
    backgroundColor: theme.palette.action.selected
  },
  vaultActions: {
    width: '90%'
  },
  newBtn: {
    backgroundColor: '#3984f7',
    color: '#fff',
    width: '50%',
    paddingTop: '1em',
    paddingBottom: '1em',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  listBtn: {
    backgroundColor: '#8BB84B',
    color: '#fff',
    width: '50%',
    paddingTop: '1em',
    paddingBottom: '1em',
    '&:hover': {
      backgroundColor: '#588518'
    },
    '&:disabled': {
      backgroundColor: 'rgba(165, 210, 101, 0.6)',
      color: 'rgba(255, 255, 255, 0.6)'
    }
  },
  contentGridHide: {
    maxHeight: '0px',
    transition: '0.5s',
    overflow: 'hidden',
    padding: '0 !important'
  },
  contentGridShow: {},
  siteModal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1500
  },
  copySettingsStyles: {
    cursor: 'pointer',
    color: '#3984f7'
  },
  copyHelperText: {
    marginLeft: '42px',
    marginTop: '3px',
    marginBottom: '10px',
    fontSize: 12,
    textTransform: 'none',
    paddingLeft: '16px',
    flexWrap: 'wrap',
    color: '#6c757d'
  },
  accorSummary: {
    paddingLeft: '0px',
    paddingRight: '0px',
    marginBottom: '5px',
    marginTop: '5px'
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
    marginTop: '8px',
    marginRight: '10px',
    marginBottom: '10px'
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.secondary,
    textAlign: 'center',
    marginTop: '10px'
  },
  accorSummRoot: {
    paddingLeft: '8px'
  },
  copySettingsBar: {
    backgroundColor: '#f8f9fa !important'
  },
  unitTree: {
    width: 'fit-content',
    marginLeft: '-0.5em',
    minWidth: '12.5em'
  }
}))

/**
 * Returns word vault forms
 */
const WordVault = () => {
  const dispatch = useDispatch()
  const classes = useStyles()

  const TreeData = useSelector(state => state.auth.unitTree)
  const unitWordVault = useSelector(state => state.words.wordVault)

  const [vaultForm, setVaultForm] = useState('main')
  const [newWord, setNewWord] = useState(false)

  const [wordVault, setWordVault] = useState({
    unitName: '',
    unitID: '',
    wordVault: []
  })

  // all possible units
  const [selectedKeys, setSelectedKeys] = useState(keyify2(TreeData))
  const [selectedKey, setSelectedKey] = useState(TreeData[0].key)

  // handles information being set by selected unit in the tree
  const handleNodeSelect = async (keySelected) => {
    if (vaultForm === 'main') {
      if (keySelected !== selectedKey) {
        setSelectedKey(keySelected)
        dispatch(getWordVault(keySelected))
      }
    } else {
      const changeStat = await ConfirmToast(
        vaultForm === 'new'
          ? { msg: 'Do you want to change units?', txt: 'This will reset any changes made.' }
          : { msg: 'Do you want to change units?' }
      )

      if (changeStat === true) {
        setSelectedKey(keySelected)
        dispatch(getWordVault(keySelected))
        setVaultForm('main')
      }
    }
  }

  const handleNodeAugment = async (key, children, isExpanded) => {
    if (isExpanded) {
      const tempSelected = [...selectedKeys]
      const keysToRemove = [key, ...keyify2(children)]

      const newSelected = tempSelected.filter((selectedKey) => keysToRemove.findIndex((removeKey) => removeKey === selectedKey) === -1)

      setSelectedKeys(newSelected)
    } else {
      const tempSelected = [...selectedKeys]
      const keysToAdd = [key, ...keyify2(children)]
      const addedKeys = []

      keysToAdd.forEach((addKey) => {
        if (tempSelected.findIndex((selectedKey) => selectedKey === addKey) === -1) {
          addedKeys.push(addKey)
        }
      })

      setSelectedKeys([...selectedKeys, ...addedKeys])
    }
  }

  const avatarBackground = (severity) => {
    switch (getSeverityClass(severity * 2)) {
      case 'mild': return classes.mild
      case 'bad': return classes.bad
      case 'okay': return classes.okay
      case 'notGreat': return classes.notGreat
      case 'warn': return classes.warn
      default: return null
    }
  }

  useEffect(() => {
    if (Object.keys(unitWordVault).length === 0) {
      dispatch(getWordVault(selectedKey))
    } else {
      if (unitWordVault.unitID !== selectedKey) {
        dispatch(getWordVault(selectedKey))
      } else {
        setWordVault(unitWordVault)
      }
    }
  }, [unitWordVault, dispatch, selectedKey])

  const handleBackTrack = async () => {
    if (newWord === false) {
      const changeStat = await ConfirmToast({ msg: 'Are you sure you want to go back?', txt: 'This will reset any changes made.' })
      if (changeStat === true) {
        setVaultForm('list')
      }
    } else {
      const changeStat = await ConfirmToast({ msg: 'Are you sure you want to go back?', txt: 'This will reset any changes made.' })
      if (changeStat === true) {
        setVaultForm('main')
        setNewWord(false)
      }
    }
  }

  const handleNewWord = async () => {
    setVaultForm('new')
    setNewWord(true)
  }

  const handleNewSave = async () => {
    setVaultForm('list')
    setNewWord(false)
  }

  const VaultForm = () => {
    switch (vaultForm) {
      case 'main':
        return (
          <WordVaultMain
            setVaultForm={setVaultForm}
            onBackTrack={handleBackTrack}
            handleNewWord={handleNewWord}
            unitName={wordVault.unitName}
            wordCount={wordVault.wordVault.length}
            useStyles={useStyles}
          />
        )
      case 'list':
        return (
          <WordVaultList
            setVaultForm={setVaultForm}
            unitName={wordVault.unitName}
            wordVault={wordVault.wordVault}
            selectedKey={selectedKey}
            useStyles={useStyles}
          />
        )
      case 'edit':
        return (
          <WordVaultEdit
            onBackTrack={() => setVaultForm('list')}
            selectedKey={selectedKey}
            getAvatarBackground={avatarBackground}
            StyledSwitch={StyledSwitch}
            StyledCheckBox={StyledCheckBox}
            CustomSlider={CustomSlider}
            useStyles={useStyles}
          />
        )
      case 'new':
        return (
          <WordVaultNew
            setVaultForm={setVaultForm}
            onBackTrack={handleBackTrack}
            onSaveBackTrack={handleNewSave}
            newWord={newWord}
            selectedKey={selectedKey}
            WordNotification={WordNotification}
            StyledSwitch={StyledSwitch}
            StyledCheckBox={StyledCheckBox}
            CustomSlider={CustomSlider}
            useStyles={useStyles}
          />
        )
      default:
        return <></>
    }
  }

  return (
    <>
      <Grid container direction='row'>
        <Grid item container direction='column' spacing={2} className='mx-auto my-auto'>

          <Grid container item direction='row'>
            <h2 className=''>Word Vault Manager</h2>
          </Grid>

          <Grid container item direction='row' spacing={2} className='mx-auto'>
            <Grid item xs={4}>
              <Paper elevation={2} className='w-100 p-3'>
                <TreeView expanded={selectedKeys} className={useStyles().unitTree} disableSelection>
                  <UnitTree
                    onNodeSelect={handleNodeSelect}
                    selectedKeys={[selectedKey]}
                    treeData={TreeData}
                    expandedKeys={selectedKeys}
                    onNodeAugment={handleNodeAugment}
                  />
                </TreeView>
              </Paper>

            </Grid>

            <Grid item xs={8}>
              {VaultForm()}
            </Grid>
          </Grid>

        </Grid>
      </Grid>
    </>
  )
}

export default WordVault
